(() => {
  'use strict';

  const destination = '/?mbchooser=all#matchboox-collectie';

  const updateCollectionLink = (scope = document) => {
    const page = scope.matches?.('.mb-page-content[data-page-handle="cadeauservice"]')
      ? scope
      : scope.querySelector?.('.mb-page-content[data-page-handle="cadeauservice"]');
    if (!page) return;
    page.querySelectorAll('a').forEach((link) => {
      if (link.textContent.trim() !== 'Bekijk de collectie') return;
      link.setAttribute('href', destination);
      link.setAttribute('data-mb-cadeauservice-chooser', '');
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.mb-page-content[data-page-handle="cadeauservice"] a');
    if (!link || link.textContent.trim() !== 'Bekijk de collectie') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(destination);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateCollectionLink(), { once: true });
  } else {
    updateCollectionLink();
  }
  window.addEventListener('load', () => updateCollectionLink(), { once: true });
  document.addEventListener('shopify:section:load', (event) => updateCollectionLink(event.target));

  const observer = new MutationObserver(() => updateCollectionLink());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
